import {PieChart, Pie, Cell, ResponsiveContainer} from "recharts"
import {Button, Card, Tooltip} from "antd"
import {
    FullscreenOutlined,
    FullscreenExitOutlined,
    WarningOutlined,
    PlayCircleOutlined,
    StopOutlined
} from "@ant-design/icons"
import styles from "../../../../pages/Companies/CompaniesColumns.module.scss"
import {RiUnpinFill} from "react-icons/ri"
import {useMemo, useState} from "react"
import {getHandleDeleteSaveCompany} from "../../../../handlers/savedCompanyHandler"
import {getHandleDeleteSaveMarket} from "../../../../handlers/savedMarketHandler"
import "./DeviceMonitoringPieChart.css"
import CardDetailSection
    from "../../../../pages/Devices/Analysis/DeviceAnalysisComponents/DeviceSection/CardDetailSection/CardDetailSection";

const DeviceMonitoringPieChart = ({
                                      title,
                                      companyInn,
                                      userToken,
                                      totalDeviceCount,
                                      totalFboxVersion,
                                      versions,
                                      openShift,
                                      closedShift,
                                      errors,
                                      onDelete,
                                      marketId,
                                  }) => {
    const [expanded, setExpanded] = useState(false)

    const versionCount = Object.keys(versions).length
    const isSingleChart = versionCount === 1

    const cardClassName = `device-status-card ${expanded ? "expanded-card" : ""} ${isSingleChart ? "single-chart-card" : "multi-chart-card"}`

    const VersionPieChart = ({version, versionData}) => {
        const {
            device_count,
            active_device_count,
            inactive_minute_device_count,
            inactive_hour_device_count,
            inactive_day_device_count
        } = versionData
        const totalInactive =
            inactive_minute_device_count +
            inactive_hour_device_count +
            inactive_day_device_count

        const isAllInactive =
            active_device_count === 0 && totalInactive === device_count

        const data = isAllInactive
            ? [
                {
                    name: "Inactive",
                    value: totalInactive,
                    color: "#bfbfbf",
                },
            ]
            : [
                {
                    name: "Active",
                    value: active_device_count,
                    color: "#52c41a",
                },
                {
                    name: "Inactive minute",
                    value: inactive_minute_device_count,
                    color: "#7815ac",
                },
                {
                    name: "Inactive hour",
                    value: inactive_hour_device_count,
                    color: "#f2a900",
                },
                {
                    name: "Inactive day",
                    value: inactive_day_device_count,
                    color: "#de0733",
                },
            ].filter(item => item.value > 0)


        const chartSize = isSingleChart ? {width: 140, height: 140} : {width: 140, height: 140}
        const radiusConfig = isSingleChart ? {innerRadius: 40, outerRadius: 60} : {innerRadius: 40, outerRadius: 60}

        const renderCustomizedLabel = ({version}) => (
            <g>
                <text x="50%" y="45%" textAnchor="middle" className="chart-main-text">
                    {`${active_device_count}/${device_count}`}
                </text>
                <text x="50%" y="55%" textAnchor="middle" className="chart-sub-text">
                    {version === 'v1' ? 'POS' : 'SCO'}
                </text>
            </g>
        )

        return (
            <div className={`version-chart-container ${isSingleChart ? "single-chart" : ""}`}>
                {/*<div className="version-header">*/}
                {/*    <Tag color={version === 'v1' ? '#108ee9' : '#ff5501'} className="version-tag">*/}
                {/*        {version}*/}
                {/*    </Tag>*/}
                {/*</div>*/}

                <div className="device-chart-container" style={chartSize}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                innerRadius={radiusConfig.innerRadius}
                                outerRadius={radiusConfig.outerRadius}
                                paddingAngle={2}
                                dataKey="value"
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color}/>
                                ))}
                            </Pie>
                            {renderCustomizedLabel(version = {version})}
                        </PieChart>
                    </ResponsiveContainer>
                </div>

                <div className="version-stats">
                    <div className="stat-item">
                        <span className="stat-label">
                            <Tooltip title="Открытая смена">
                                <PlayCircleOutlined/>
                            </Tooltip>
                        </span>
                        <span className="stat-value">{openShift}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">
                            <Tooltip title="Закрытая смена">
                                <StopOutlined/>
                            </Tooltip>
                        </span>
                        <span className="stat-value">{closedShift}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">
                            <Tooltip title="Ошибки">
                                <WarningOutlined style={{color: "#ff4d4f"}}/>
                            </Tooltip>
                        </span>
                        <span className="stat-value error">{errors}</span>
                    </div>
                </div>
            </div>
        )
    }

    // Memoized delete handler
    const getDeleteHandler = useMemo(() => {
        if (marketId) {
            return {
                handler: getHandleDeleteSaveMarket(null, userToken),
                record: {market_id: marketId},
            }
        }
        return {
            handler: getHandleDeleteSaveCompany(null, userToken),
            record: {company_inn: companyInn, company_name: title},
        }
    }, [marketId, userToken, companyInn, title])

    const handleDeleteClick = (e) => {
        e.stopPropagation()
        getDeleteHandler.handler(getDeleteHandler.record, onDelete)
    }

    return (
        <Card className={cardClassName}>
            <div className="card-header">
                <h3 className="card-title">{title}</h3>
            </div>

            <div className="total-stats-header">
                <div className="total-stat">
                    <span>Total Devices: {totalDeviceCount}</span>
                </div>
                {/*<div className="total-stat">*/}
                {/*    <span>Versions: {totalFboxVersion}</span>*/}
                {/*</div>*/}
            </div>

            <div className={`card-content ${expanded ? "expanded-layout" : ""}`}>
                <div className="charts-section">
                    <div className="versions-container">
                        {Object.entries(versions).map(([version, versionData]) => (
                            <VersionPieChart key={version} version={version} versionData={versionData}/>
                        ))}
                    </div>

                    <div className="global-stats-container">
                        <div className="stats-row">
                            <RiUnpinFill size={18} className={styles.savedHeartIcon} onClick={handleDeleteClick}/>
                            <Button
                                type="text"
                                icon={expanded ? <FullscreenExitOutlined/> : <FullscreenOutlined/>}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setExpanded((prev) => !prev)
                                }}
                                className="toggle-expand-btn"
                            />
                        </div>
                    </div>
                </div>

                {expanded && (
                    <div className="details-section">
                        <CardDetailSection companyInn={companyInn} marketId={marketId} userToken={userToken}/>
                    </div>
                )}
            </div>
        </Card>
    )
}

export default DeviceMonitoringPieChart
